import Image from "next/image";
import Link from "next/link";

const Cards = ({
  cardImgSrc,
  cardImgAlt,
  cardImgLoading = "lazy",
  cardImgHidden = false,
  cardTagText1,
  cardTagText2,
  cardHeadingText1,
  cardHeadingText2,
  cardHeadingText3,
  cardDescText1,
  cardDescText2,
  cardDescText3,
  cardRowReverse = false,
  cardBtnText1,
  cardBtnLink1 = "#",
  cardBtnText2,
  cardStyles,
  cardImgStyles,
  cardClassName = "",
  cardImgFullWidth = false,
  cardDisplayTextSection = true,
}) => {
  return (
    <div
      style={cardStyles}
      className={`${cardClassName} ${
        cardRowReverse ? "md:flex-row-reverse" : "md:flex-row"
      } w-full max-w-7xl flex flex-col justify-center items-center mt-40`}
    >
      {!cardImgHidden && (
        <Image
          className={`w-full ${cardImgFullWidth ? "md:w-3/4" : "md:w-1/2"}`}
          src={cardImgSrc}
          style={cardImgStyles}
          alt={cardImgAlt}
          loading={cardImgLoading}
          width="500"
          height="500"
        />
      )}
      {cardDisplayTextSection && (
        <div className="w-full mt-10 md:mt-0 md:w-1/2 flex justify-center items-start">
          <div className="w-full sm:w-3/4">
            {cardTagText1 && (
              <h3 className="text-center w-fit py-1 px-4 rounded-full font-medium text-white text-base md:text-lg mt-4 bg-[#915bff]">
                {cardTagText1}
              </h3>
            )}
            {cardTagText2 && (
              <h3 className="w-fit py-1 rounded-full font-semibold text-2xl sm:text-3xl md:text-4xl mt-4 text-[#915bff]">
                {cardTagText2}
              </h3>
            )}
            {cardHeadingText1 && (
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-semibold mt-4 leading-[1.375!important]">
                {cardHeadingText1}
              </h3>
            )}
            {cardDescText1 && (
              <p className="text-base md:text-lg mt-3">{cardDescText1}</p>
            )}
            {cardHeadingText2 && (
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-semibold mt-10">
                {cardHeadingText2}
              </h3>
            )}
            {cardDescText2 && (
              <p className="text-base md:text-lg mt-3">{cardDescText2}</p>
            )}
            {cardHeadingText3 && (
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-semibold mt-4">
                {cardHeadingText3}
              </h3>
            )}
            {cardDescText3 && (
              <p className="text-base md:text-lg mt-3">{cardDescText3}</p>
            )}
            <div className="w-full flex flex-col lg:flex-row justify-start items-center gap-2 lg:gap-3 mt-5">
              {cardBtnText1 && (
                <Link
                  target="_self"
                  href={cardBtnLink1}
                  className="w-full lg:w-1/2 text-lg text-center font-semibold px-3 lg:px-4 py-2 border-2 border-[#915bff] rounded-lg text-[#915bff] hover:bg-[#a97dff] hover:text-white transition-colors"
                >
                  {cardBtnText1}
                </Link>
              )}
              {cardBtnText2 && (
                <Link
                  target="_"
                  href={"https://approval-dashboard.boloforms.com/login"}
                  className="w-full lg:w-1/2 text-lg text-center font-medium px-3 lg:px-4 py-2 rounded-lg bg-[#915bff] text-white hover:opacity-90 transition-colors"
                >
                  {cardBtnText2}
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cards;
